import React, { Component } from 'react';
import { BreadCrumb, Card } from '../../components';
import { LanguageConsumer, Translate } from '../../contexts/LanguageContext';
import { UserAccounts } from '../../components/UserAccounts';
import { DataTableColumns } from '../../helpers/DataTableColumns';
import DataTable from 'react-data-table-component'


export class Home extends Component {

    constructor(props) {
        super(props)
        this.state = {
            userAccount: {
                active: null,
                list: [],
                info: {
                    "email": "",
                    "ip": "",
                    "country": "",
                    "name": "",
                    "currency": "",
                    "login": 0,
                    "equity": 0.0,
                    "balance": 0.0,
                    "margin": 0.0,
                    "margin_Free": 0.0,
                    "margin_Level": 0.0,
                    "profit": 0.0,
                    "totalDeposit": 0,
                    "totalWithdrawal": 0,
                    "openTrades": [],
                    "pendingTrades": [],
                    "transferHistory": []
                }
            }
        }

        this.changeAccount = this.changeAccount.bind(this);
    }
    changeAccount(userAccount) {
        this.setState({
            userAccount: userAccount
        });
    }
    render() {

        const openPositionsData = {
            columns: DataTableColumns.openTrades,
            rows: this.state.userAccount.info.openTrades
        };

        const pendingPositionsData = {
            columns: DataTableColumns.openTrades,
            rows: this.state.userAccount.info.pendingTrades
        };

        return (
            <LanguageConsumer>
                {() => (
                    <React.Fragment>
                        <BreadCrumb Title={Translate('Home')} Description={Translate('Welcome to Customer Panel')} />
                        <div className="tra-home__wrapper">
                        <div className="row first-row">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-4 section-left pb-10">
                                <Card Title={Translate('User Accounts')} Description={Translate('Select the account to be active.')} className="tra-user-account__info pb-2">
                                    <div className="row">
                                        <div className="col-12 col-xl-6">                                           
                                           <UserAccounts Dashboard Change={(e, userAccount) => this.changeAccount(userAccount)} />
                                           <h6 className="text-ellipsis font-14" title={this.state.userAccount.info.email}><i className="fas fa-envelope fas-center ml-2 pt-2"></i> {this.state.userAccount.info.email}</h6>
                                            <h6 className="text-ellipsis font-14"><i className="fas fa-map-marker-alt fas-center ml-2"></i> {this.state.userAccount.info.country}</h6>
                                            <h6 className="text-ellipsis font-14"><i className="fas fa-globe fas-center ml-2"></i> {this.state.userAccount.info.ip}</h6>          
                                       </div>
                                        <div className="col-12 col-xl-6">
                                                <dl className="row mb-0">
                                                <dt className="col-sm-4">{Translate('Name')}</dt>
                                                <dd className="col-sm-8 text-ellipsis" title={this.state.userAccount.info.name}>{this.state.userAccount.info.name}</dd>
                                                <dt className="col-sm-4">{Translate('Equity')}</dt>
                                                <dd className="col-sm-8">{this.state.userAccount.info.equity.toFixed(2).format('C')}</dd>
                                                <dt className="col-sm-4">{Translate('Balance')}</dt>
                                                <dd className="col-sm-8">{this.state.userAccount.info.balance.toFixed(2).format('C')}</dd>
                                                <dt className="col-sm-4">{Translate('Margin')}</dt>
                                                <dd className="col-sm-8">{this.state.userAccount.info.margin.toFixed(2).format('C')}</dd>
                                                <dt className="col-sm-4">{Translate('Free Margin')}</dt>
                                                <dd className="col-sm-8">{this.state.userAccount.info.margin_Free.toFixed(2).format('C')}</dd>
                                                <dt className="col-sm-4">{Translate('Margin Level')}</dt>
                                                <dd className="col-sm-8">{this.state.userAccount.info.margin_Level.toFixed(2).format('C')}</dd>
                                                <dt className="col-sm-4">{Translate('Profit')}</dt>
                                                <dd className="col-sm-8">{this.state.userAccount.info.profit.toFixed(2).format('C')}</dd>
                                                </dl>                         
                                        </div>
                                       
                                    </div>                                   
                                </Card>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-3 section-center">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="card mini-stat">
                                            <div className="card-body">
                                                <div className="mb-4">
                                                    <div className="float-left mini-stat-img mr-4 bg-warning text-white">
                                                        <i className="fas fa-money-bill-alt font-30"></i>
                                                    </div>
                                                    <h5 className="font-16 text-uppercase mt-0">{Translate('Total Withdrawal')}</h5>
                                                    <h4 className="font-500">{this.state.userAccount.info.totalWithdrawal.toFixed(2).format('C')} {this.state.userAccount.info.currency}</h4>
                                                </div>
                                                <div className="pt-2">
                                                    <p className=" mb-0">{Translate('All transactions made to date')}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="card mini-stat">
                                            <div className="card-body">
                                                <div className="mb-4">
                                                    <div className="float-left mini-stat-img mr-4 bg-success text-white">
                                                        <i className="fas fa-wallet font-30"></i>
                                                    </div>
                                                    <h5 className="font-16 text-uppercase mt-0">{Translate('Total Deposit')}</h5>
                                                    <h4 className="font-500">{this.state.userAccount.info.totalDeposit.toFixed(2).format('C')} {this.state.userAccount.info.currency}</h4>
                                                </div>
                                                <div className="pt-2">
                                                    <p className="mb-0">{Translate('All transactions made to date')}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5 section-right">
                                <Card Title={Translate('Latest Money Transfers')} Description={Translate("Last transfer transactions")} className="min-height-dashboard">

                                    {this.state.userAccount.info.transferHistory.length === 0 ? (
                                        <div className="alert alert-light" role="alert">
                                            <em><strong>{Translate('No Record')}!</strong> {Translate('No transfer history')}.</em>
                                        </div>) :
                                        (<DataTable
                                            noHeader={true}
                                            columns={DataTableColumns.transferHistory}
                                            data={this.state.userAccount.info.transferHistory}
                                        />)}

                                </Card>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <Card Title={Translate('Open Positions')} Description={Translate('Your open transactions')}>
                                    {this.state.userAccount.info.openTrades.length === 0 ? (
                                        <div className="alert alert-light" role="alert">
                                            <em><strong>{Translate('No Record')}!</strong> {Translate('You have no open orders')}.</em>
                                        </div>) :
                                        (<DataTable
                                            noHeader={true}
                                            columns={openPositionsData.columns}
                                            data={openPositionsData.rows}
                                            defaultSortField="ticket"
                                            defaultSortAsc={false}
                                            paginationPerPage={5}
                                            paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
                                            pagination
                                            highlightOnHover />)}
                                </Card>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <Card Title={Translate("Pending Orders")} Description={Translate("Your pending transactions")}>
                                    {this.state.userAccount.info.pendingTrades.length === 0 ? (
                                        <div className="alert alert-light" role="alert">
                                            <em><strong>{Translate('No Record')}!</strong> {Translate('You have no pending orders')}.</em>
                                        </div>) :
                                        (<DataTable
                                            noHeader={true}
                                            columns={pendingPositionsData.columns}
                                            data={pendingPositionsData.rows}
                                            defaultSortField="ticket"
                                            defaultSortAsc={false}
                                            paginationPerPage={5}
                                            paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
                                            pagination
                                            highlightOnHover />)}
                                </Card>
                            </div>
                        </div>
                    
                        </div>
                       </React.Fragment>
                )}
            </LanguageConsumer>

        )
    }
}

